// extracted by mini-css-extract-plugin
module.exports = {"info":"DragDropButton_info__3GOXD","description":"DragDropButton_description__2wHz7","uploadAction":"DragDropButton_uploadAction__wBIbH"};